import { render, staticRenderFns } from "./headercard-component.vue?vue&type=template&id=920c7450"
import script from "./headercard-component.vue?vue&type=script&lang=ts"
export * from "./headercard-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports